import { useEffect, useRef } from "react";
import { useGlobalState } from "./use-global-state";

export function useTitle(propTitle?: string): string {
  const defTitle = "HeyUp.ai";
  const refTitle = useRef<string>("");
  const [title, setTitle] = useGlobalState<string>("page-title", defTitle);

  useEffect(() => {
    if (propTitle !== undefined && propTitle !== refTitle.current) {
      refTitle.current = propTitle;
      const titleToSet = propTitle === "" ? defTitle : propTitle;
      document.title = titleToSet;
      setTitle(titleToSet);
    }
  }, [propTitle, setTitle]);

  return title!;
}
